export default "/images/project6.jpeg?87db9b2ea5e7a46cdb807f572203a457";